import { createFileRoute, Link } from "@tanstack/react-router";

import { title } from "@/components/base/primitives";
import { RegisterUserForm } from "@/components/users/register-user-form";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/sign-up")({
  head: () => ({
    meta: [
      {
        title: "CBVA Sign Up",
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-6 px-3 text-center">
        <h1 className={title({ size: "lg" })}>
          Sign Up to Become a CBVA Member
        </h1>

        <p>
          Already have an account?{" "}
          <Link to="/log-in" className="underline hover:no-underline">
            Log in
          </Link>
        </p>
      </div>

      <div className="mx-auto w-full max-w-md px-3">
        <RegisterUserForm className="w-full rounded-lg bg-white p-8" />
      </div>
    </DefaultLayout>
  );
}
